import { type ReactNode } from "react";
import { Navigate } from "react-router";
import { CREATE, DELETE, MODIFY, PUCK_PAGE, useFoodpilotContext } from "src/context/FoodpilotContext";
import type { Slugs } from "src/context/ProtectedContext";

type CMSPagesProtectionProps = {
    action?: Slugs;
    children: ReactNode;
};

export const CMSPagesProtection = (props: CMSPagesProtectionProps) => {
    const { action, children } = props;
    const { canUser } = useFoodpilotContext();
    const canAccessCmsPages =
        action ?
            canUser(action, PUCK_PAGE)
        :   canUser(CREATE, PUCK_PAGE) || canUser(MODIFY, PUCK_PAGE) || canUser(DELETE, PUCK_PAGE);

    if (!canAccessCmsPages) {
        return <Navigate to="/settings" replace />;
    }

    return children;
};
